import { requestFactory } from '@/plugins/axios'
// {id}
export function defectDel(data) {
   return requestFactory({
        url: 'defectRecord/delete/',
        method: 'DELETE',
        data: data
      }, true)
}
// {parameterList}
export function changePage(params) {
  return requestFactory({
        url: '/defectRecord/findByMachineIdAndHappenTime',
        method: 'GET',
        params: params
      })
}
// {id}
export function removeById(id) {
   return requestFactory({
        url: `defectRecord/delete/${id}`,
        method: 'DELETE'
      }, true)
}
